import moment from 'moment';

export const KIND = {
  wedding: { label: 'Düğün', dot: 'bg-rose-500', pill: 'bg-rose-500/10 text-rose-700 dark:text-rose-300 border-rose-500/30', bar: 'bg-rose-500' },
  extra: { label: 'Ek Gün (Nişan, Kına, Dış Çekim...)', dot: 'bg-violet-500', pill: 'bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/30', bar: 'bg-violet-500' },
  shoot: { label: 'Çekim', dot: 'bg-sky-500', pill: 'bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/30', bar: 'bg-sky-500' },
  appointment: { label: 'Randevu', dot: 'bg-amber-500', pill: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30', bar: 'bg-amber-500' },
};

export const kindOf = (ev) => {
  const r = ev.resource || {};
  if (r.isCustomerWedding) return r.isMainEvent ? 'wedding' : 'extra';
  if (r.event_type === 'appointment') return 'appointment';
  return 'shoot';
};

export const dayKey = (d) => moment(d).format('YYYY-MM-DD');

export const groupByDay = (events) => {
  const map = {};
  events.forEach(ev => {
    const k = dayKey(ev.start);
    (map[k] = map[k] || []).push(ev);
  });
  Object.values(map).forEach(list => list.sort((a, b) => a.start - b.start));
  return map;
};

export const timeLabel = (ev) => {
  const r = ev.resource || {};
  const s = r.currentEvent?.event_time_start || r.wedding_time_start || r.time;
  const e = r.currentEvent?.event_time_end || r.wedding_time_end;
  return s ? (e ? `${s}–${e}` : s) : '';
};

export const nameOf = (ev) => {
  const r = ev.resource || {};
  if (r.isCustomerWedding) return `${r.bride_name || ''} & ${r.groom_name || ''}`;
  return r.customer_name || ev.title;
};

export const subtitleOf = (ev, extraLabels) => {
  const r = ev.resource || {};
  if (r.isCustomerWedding) {
    const type = r.currentEvent?.event_type;
    const loc = r.currentEvent?.location || r.venue_name || r.location;
    return [r.isMainEvent ? 'Düğün' : (extraLabels[type] || 'Etkinlik'), loc].filter(Boolean).join(' · ');
  }
  return ev.title.split(' - ').slice(1).join(' - ') || KIND[kindOf(ev)].label;
};
